const Tabs = (() => {
  const buttons = Array.from(document.querySelectorAll('.c-tabs-tab')),
        panels = Array.from(document.querySelectorAll('.c-tabs-panel'));

  const show = (activeTab) => {
    let activePanel = document.getElementById(activeTab.getAttribute('aria-controls'));

    window.location.hash = `panel-${activeTab.getAttribute('id')}`;

    buttons.forEach(tab => {
      if (tab != activeTab) {
        tab.setAttribute('aria-selected', false);
        tab.setAttribute('tabindex', -1);
      } else {
        tab.setAttribute('aria-selected', true);
        tab.removeAttribute('tabindex');
      }
    });

    panels.forEach(panel => {
      if (panel != activePanel) {
        panel.setAttribute('aria-hidden', true);
      } else {
        panel.setAttribute('aria-hidden', false);
      }
    });
  };

  const trap = (e, tab) => {
    const keys = {
      end: 35,
      home: 36,
      left: 37,
      up: 38,
      right: 39,
      down: 40
    }

    let first = buttons[0],
        last = buttons[buttons.length - 1],
        next = tab.nextElementSibling || first,
        prev = tab.previousElementSibling || last;

    if (e.which == keys.right) {
      show(next);
      next.focus();
    } else if (e.which == keys.left) {
      show(prev);
      prev.focus();
    } else if (e.which == keys.home) {
      show(first);
      first.focus();
    } else if (e.which == keys.end) {
      show(last);
      last.focus();
    }
  }

  return {
    init: () => {
      if (panels.length > 0) { 
        let hashId = window.location.hash.replace('panel-', '');

        if (hashId && buttons.indexOf(document.querySelector(hashId)) >= 0) {
          show(document.querySelector(hashId));
        } else {
          show(buttons[0]);
        }

        panels.forEach(panel => {
          panel.setAttribute('tabindex', 0);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', `${panel.getAttribute('id')}Btn`);
        });

        buttons.forEach(tab => {
          tab.onclick = () => {
            show(tab);
          };
          tab.onkeydown = (e) => {
            trap(e, tab);
          };
        });
      }
    },
    destroy: () => {
      panels.forEach(panel => {
        panel.removeAttribute('tabindex');
        panel.removeAttribute('role');
        panel.removeAttribute('aria-labelledby');
        panel.removeAttribute('aria-hidden');
      });
    }
  }
})();

export default Tabs;


// WEBPACK FOOTER //
// ./src/js/components/tabs.js